import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import CarouselRail from "@/components/yts/CarouselRail";
import { RENTAL_COMPANIES } from "@/data/rentals";
import { useLang } from "@/lib/i18n";

/**
 * A real rental directory instead of logo-only links. Company descriptions
 * and direct booking URLs are supplied by the existing verified directory.
 */
export default function RentalCarsRail() {
  const { lang } = useLang();
  const es = lang === "es";
  return (
    <CarouselRail
      title={es ? "ALQUILA UN AUTO." : "RENT A CAR."}
      subtitle={es ? "Marcas del aeropuerto y compañías locales." : "Airport brands and island-owned providers."}
      itemWidth="w-[min(78vw,280px)] min-w-[230px] sm:w-[280px] sm:min-w-0"
      action={<Link to="/auto" className="hidden text-[11px] font-semibold uppercase tracking-wide text-[#77736c] hover:text-[#D9232E] sm:inline-flex sm:items-center sm:gap-1">{es ? "Ver todas" : "See all"} <ArrowUpRight className="h-4 w-4" /></Link>}
    >
      {RENTAL_COMPANIES.map((company) => (
        <a
          key={company.name}
          href={company.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${company.name} — ${es ? "visitar compañía de alquiler" : "visit rental company"}`}
          className="group flex h-full min-h-[256px] flex-col rounded-[9px] border border-[#E5E4E0] bg-white p-3 text-[#111111] transition-colors hover:border-[#96928a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9232E]"
        >
          <div className="flex h-[88px] w-full items-center justify-center overflow-hidden rounded-[6px] border border-[#EDEBE7] bg-[#FAF9F6] p-3">
            {company.logo ? (
              <img src={company.logo} alt={`${company.name} logo`} loading="lazy" decoding="async" className={company.bleed ? "h-full w-full object-contain" : "h-auto w-auto max-h-[65px] max-w-[85%] object-contain"} />
            ) : (
              <span className="text-[32px] font-black tracking-[-0.05em]">{company.mark}</span>
            )}
          </div>
          <h3 className="mt-3 line-clamp-1 text-[15px] font-bold tracking-[-0.025em]">{company.name}</h3>
          <p className="mt-1 line-clamp-2 min-h-[2.8em] text-[11.5px] leading-[1.45] text-[#65615c]">{es ? company.blurb_es : company.blurb_en}</p>
          <div className="mt-auto flex items-center justify-between gap-2 border-t border-[#E5E4E0] pt-3">
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.08em] text-[#B3262E]">{es ? "Ver alquiler" : "View rental"} <ArrowUpRight className="h-3.5 w-3.5" /></span>
            {company.local && <span className="rounded-full border border-[#d6d3ce] px-2 py-1 text-[9px] font-semibold uppercase tracking-[0.1em]">{es ? "Local" : "Local"}</span>}
          </div>
        </a>
      ))}
    </CarouselRail>
  );
}
